import { all } from 'redux-saga/effects';
import TrialSitesSagas from 'widgets/Sites/FindSite/provider/sagas';
import TrialCountrySitesSagas from 'widgets/Sites/CountrySite/provider/sagas';

export default function* rootSaga() {
  yield all([...TrialSitesSagas, ...TrialCountrySitesSagas]);
}
